import { PRODUCT_MODEL_KEY_POINTER } from 'models/daos/product/constants'

const PRODUCTS_DOMAIN = 'products'
const PRODUCTS_PATH = {
  DATA: `${PRODUCTS_DOMAIN}.data`
}

const PRODUCTS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const PRODUCTS_DOMAIN_MAP_KEY = PRODUCT_MODEL_KEY_POINTER

export {
  PRODUCTS_DOMAIN,
  PRODUCTS_PATH,
  PRODUCTS_STATE,
  PRODUCTS_DOMAIN_MAP_KEY
}
